import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeamspeakComponent } from './simple-icons-teamspeak.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeamspeakComponent ],
    exports:      [ SimpleIconsTeamspeakComponent ],
    bootstrap:    []
})
export class SimpleIconsTeamspeakModule {}
